import { takeEvery, put, call } from 'redux-saga/effects';
import Api from '../functions/Api';
import * as types from '../constants/ActionTypes';

export function* fetchLanguages({ locale } = {}) {
  try {
    // v1 returns the array itself, unwrapped, and only the languages that are not hidden.
    // Names come in the request's language, so pin it to the UI locale, not the browser's.
    const data = yield call(Api.get, 'v1/languages/', { locale });

    yield put({
      type: types.FETCH_LANGUAGES_SUCCESS,
      payload: data,
    });
    yield put({
      type: types.ADD_LANGUAGES_FOR_USER_STATE,
      data,
    });
    yield put({
      type: types.RECEIVE_LANGUAGES,
      data,
    });
  } catch (error) {
    yield put({
      type: types.FETCH_LANGUAGES_FAILURE,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export default function* watchLanguages() {
  yield takeEvery(types.FETCH_LANGUAGES, fetchLanguages);
}
